const recaptchaSiteKeyFromWindow =
  typeof window !== 'undefined' ? window.RECAPTCHA_SITE_KEY : '';

export const RECAPTCHA_SITE_KEY = process.env.MIX_RECAPTCHA_SITE_KEY || recaptchaSiteKeyFromWindow || '';
